import { ComponentType } from 'react'

import { registerSharedDependency } from 'core-components/helpers/MFHelper'
import Logger from 'src/core/utils/Logger'

export interface IBaseNotificationData {
  Message: string
  Date: string
  Subject: string
  Author?: string
}

class NotificationControllerClass {
  private templateLoaders: {
    [key: string]: () => Promise<{ default: ComponentType<any> }>
  } = {}

  public addTemplate = (
    templateName: string,
    loadTemplateFunction: () => Promise<{ default: ComponentType<any> }>
  ): void => {
    if (!this.templateLoaders[templateName]) {
      this.templateLoaders[templateName] = loadTemplateFunction
    } else {
      Logger.error(`Notification template with name ${templateName} already exist`)
    }
  }
  public getTemplate = (
    templateName: string
  ): (() => Promise<{ default: ComponentType<any> }>) | void => {
    if (templateName in this.templateLoaders) {
      return this.templateLoaders[templateName]
    }
    // throw new Error(
    //   `Notification template with name ${templateName} doesn't exist`
    // )
  }
  public sendNotification = (
    data: IBaseNotificationData,
    TemplateName: string,
    notificationSettings: NotificationOptions
  ): void => {}
}

export const NotificationController = registerSharedDependency<NotificationControllerClass>(
  'PushNotificationController',
  () => new NotificationControllerClass()
)
